'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_Person(firstname, lastname, age, extra_str, extra_int) {
  this.sH = null;
  this.sI = null;
  this.k9 = 0;
  this.sG = null;
  this.sF = null;
  this.sH = firstname;
  this.sI = lastname;
  this.k9 = age;
  this.sG = extra_str;
  this.sF = extra_int;
}
export { $c_Lsamples_Person as $c_Lsamples_Person };
$p = $c_Lsamples_Person.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Person;
/** @constructor */
function $h_Lsamples_Person() {
}
export { $h_Lsamples_Person as $h_Lsamples_Person };
$h_Lsamples_Person.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.m = (function() {
  var acc = (-889275714);
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, (-1907849355));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.sH));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.sI));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, this.k9);
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.sG));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.sF));
  return $j_java$002elang$002e$002dObject.$m_sr_Statics$().an(acc, 5);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsamples_Person)) {
    if ((((this.k9 === x$0.k9) && (this.sH === x$0.sH)) && (this.sI === x$0.sI))) {
      var x = this.sG;
      var x$2 = x$0.sG;
      var $x_1 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3 = this.sF;
      var x$4 = x$0.sF;
      return ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.b = (function() {
  return $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().ah(this);
});
$p.n = (function() {
  return 5;
});
$p.o = (function() {
  return "Person";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.sH;
      break;
    }
    case 1: {
      return this.sI;
      break;
    }
    case 2: {
      return this.k9;
      break;
    }
    case 3: {
      return this.sG;
      break;
    }
    case 4: {
      return this.sF;
      break;
    }
    default: {
      throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__I__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Lsamples_Person(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ej)));
}
export { $isArrayOf_Lsamples_Person as $isArrayOf_Lsamples_Person };
var $d_Lsamples_Person = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Person, "samples.Person", ({
  ej: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lsamples_Person as $d_Lsamples_Person };
